// extracted by mini-css-extract-plugin
module.exports = {"containerWithAvatar":"MainCardContainer-module_containerWithAvatar_8f322","rightContainer":"MainCardContainer-module_rightContainer_6ec3f"};